import { Tab, Tabs } from "@mui/material";
import CustomBreadcrumbs from "../../../components/custom-breadcrumbs/custom-breadcrumbs";
import PageComponent from "../../../components/page";
import { useResponsive } from "../../../hooks/use-responsive";
import useUserUpdate from "./useUpdate";
import { tabsUpdate } from "../../../constants/user";
import Iconify from "../../../components/iconify";
import UpdateDataUserView from "./views/data";
import UpdatePasswordUserView from "./views/password";
import UpdateSystemsUserView from "./views/systems";

const UpdateUserPage = () => {

    const mdUp = useResponsive('up', 'md');

    const { currentTab, handleChangeTab } = useUserUpdate();

    return (
        <PageComponent>
            <>
                <CustomBreadcrumbs
                    heading="Editar Usuário"
                    links={[
                        {
                            name: 'Usuários',
                            href: '/users'
                        },
                        {
                            name: 'Editar'
                        }
                    ]}
                    sx={{ mb: { xs: 3, md: 5 } }}
                />
                <Tabs
                    value={currentTab}
                    onChange={handleChangeTab}
                    sx={{ mb: { xs: 3, md: 5 } }}
                >
                    {
                        tabsUpdate.map((tab) => (
                            <Tab key={tab.value} label={tab.label} icon={<Iconify icon={tab.icon} />} value={tab.value} />
                        ))
                    }
                </Tabs>

                {currentTab == 'data' && <UpdateDataUserView />}
                {currentTab == 'password' && <UpdatePasswordUserView />}
                {currentTab == 'systems' && <UpdateSystemsUserView />}
            </>
        </PageComponent>
    );

}

export default UpdateUserPage;